import { Card, Box, Icon } from '@nimbus-ds/components';
import { ChevronRightIcon } from '@nimbus-ds/icons';
import { LocationSelector } from 'domains/Catalog/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

interface SourceDestinationCardProps {
  sourceLocationId?: string;
  destinationLocationId?: string;
  onSelectSource: (locationId: string) => void;
  onSelectDestination: (locationId: string) => void;
  disabledSource?: boolean;
  disabledDestination?: boolean;
}

function SourceDestinationCard({
  sourceLocationId,
  destinationLocationId,
  onSelectSource,
  onSelectDestination,
  disabledSource,
  disabledDestination,
}: Readonly<SourceDestinationCardProps>) {
  const t = useTranslationCatalog();

  return (
    <Card>
      <Card.Header title={t('transfers.new.sourceDestination.title')} />
      <Card.Body>
        <Box display="flex" gap="4" alignItems="flex-start">
          <Box flex="1">
            <LocationSelector
              selectedLocationId={sourceLocationId}
              label={t('transfers.new.sourceDestination.source.label')}
              placeholder={t(
                'transfers.new.sourceDestination.source.placeholder',
              )}
              showPrefix={false}
              showAddress
              onSelectionChange={onSelectSource}
              disabled={disabledSource}
            />
          </Box>

          <Box alignSelf="center">
            <Icon source={<ChevronRightIcon />} color="neutral-textLow" />
          </Box>

          <Box flex="1">
            <LocationSelector
              selectedLocationId={destinationLocationId}
              label={t('transfers.new.sourceDestination.destination.label')}
              placeholder={t(
                'transfers.new.sourceDestination.destination.placeholder',
              )}
              showPrefix={false}
              showAddress
              showWhenJustOneLocation
              disabled={disabledDestination}
              excludeLocationId={disabledSource ? sourceLocationId : undefined}
              onSelectionChange={onSelectDestination}
            />
          </Box>
        </Box>
      </Card.Body>
    </Card>
  );
}

export default SourceDestinationCard;
